import React from 'react'
import { Row , Col } from 'antd'
import SiloShots from './SiloShots'
import SiloSettingsPresets from './SiloSettingsPresets'

export default function SiloSubmitRequest(props) {
  return (
    <div className="silo-content">
        <Row style={{height:"98%"}}>
            <Col style={{height:"100%", overflowY:"scroll"}} className='custom-scroll' span={18}>
                <SiloShots setResolutionBar={false} {...props}/>
            </Col>
            <Col span={6} style={{height:"100%"}}> 
              <SiloSettingsPresets {...props}/>
            </Col>
        </Row>
    </div>
  )
}
